import { render, staticRenderFns } from "./BaseTextOutput.vue?vue&type=template&id=58b792ee"
import script from "./BaseTextOutput.vue?vue&type=script&lang=js"
export * from "./BaseTextOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports